import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { mapValues } from "lodash";

import loadFeatureFlags from "src/services/featureFlags";
import Auth0UserProps from "src/custom-prop-types/auth0user";
import { Provider } from "./FeatureFlagsContext";

const FeatureFlagsContextProvider = (props) => {
  const { children, user } = props;

  const [featureFlags, setFeatureFlags] = useState({});

  useEffect(() => {
    let cancelled = false;

    // Always mark loaded — Flagsmith is best-effort; a hung/failed init must
    // not block WorkspaceChallenge behind isFeatureFlagsLoaded.
    loadFeatureFlags(user)
      .then((allFeatureFlags) => {
        if (cancelled) return;
        const enabledFeatureFlags = mapValues(allFeatureFlags, "enabled");
        setFeatureFlags({
          ...enabledFeatureFlags,
          isFeatureFlagsLoaded: true,
        });
      })
      .catch(() => {
        if (cancelled) return;
        setFeatureFlags({ isFeatureFlagsLoaded: true });
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  const values = { featureFlags };

  return <Provider {...values}>{children}</Provider>;
};

FeatureFlagsContextProvider.propTypes = {
  user: Auth0UserProps,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default FeatureFlagsContextProvider;
